var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_43",
    "data-name": "Group 43",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 80,
    height: 80,
    rx: 10,
    fill: "rgba(226,78,178,0.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(19.516 19)",
    fill: "none",
    stroke: "#e24eb2",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 19.5,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M-1,1.74H.28V.12C3.2-.08,4.8-1.98,4.8-4.02c0-2.96-2.44-3.5-4.52-4.04v-3.78a1.833,1.833,0,0,1,1.34,1.62H4.64C4.46-12.6,2.78-13.94.28-14.14v-1.62H-1v1.62c-2.6.2-4.48,1.74-4.48,4.1C-5.48-7.08-3.06-6.5-1-5.98v3.82A1.78,1.78,0,0,1-2.48-3.9h-3C-5.42-1.5-3.58-.12-1,.1ZM1.9-3.9A1.788,1.788,0,0,1,.28-2.12v-3.5C1.22-5.3,1.9-4.84,1.9-3.9Zm-4.46-6.28A1.651,1.651,0,0,1-1-11.9v3.46C-1.92-8.76-2.56-9.24-2.56-10.18Z",
    transform: "translate(41 47)",
    fill: "#e24fb2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.2f96d61d.svg";
export { ForwardRef as ReactComponent };